import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation } from "swiper/modules";
import { useCity } from "../context/CityContext";

import "swiper/css/navigation";
import "swiper/css";
import "../styles/NewHome.css";

import eventShareIcon from "../ui-assets/home/share.svg";
import eventBackcardIcon from "../ui-assets/home/event-back-date-icon.svg";
import { API_BASE_URL } from "../config";
import { toast } from "react-toastify";

const ShareModal = ({ eventId, onClose }) => {
  const [copied, setCopied] = useState(false);

  const baseUrl = window.location.origin;
  const eventLink = `${baseUrl}/eventpage/${eventId}`;

  const handleCopy = () => {
    navigator.clipboard.writeText(eventLink).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2500);
    });
  };

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div className="pshare-modal-overlay" onClick={handleBackdropClick}>
      <div className="share-modal">
        <div className="share-modal-header">
          <h5 className="share-modal-title">Share event link</h5>
          <button
            className="share-modal-close"
            onClick={onClose}
            aria-label="Close"
          >
            &times;
          </button>
        </div>
        <div className="share-modal-body">
          <div className="share-modal-input-row">
            <input
              type="text"
              className="share-modal-input"
              value={eventLink}
              readOnly
            />
            <button
              className={`share-modal-copy-btn${copied ? " copied" : ""}`}
              onClick={handleCopy}
            >
              {copied ? "Copied!" : "Copy"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

const HometrendingEvents = () => {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [shareEventId, setShareEventId] = useState(null);
  const navigate = useNavigate();
  const { selectedCity } = useCity();

  useEffect(() => {
    const token = localStorage.getItem("token");
    setLoading(true);

    const cityParam = selectedCity ? `&city=${selectedCity}` : "";
    const url = `${API_BASE_URL}/gettrending_events?page=1&npp=70${cityParam}`;

    fetch(url, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    })
      .then((res) => res.json())
      .then((data) => {
        console.log("TRENDING EVENTS API 👉", data);
        setEvents(data?.result || []);
      })
      .catch((err) => console.error("API Error ❌", err))
      .finally(() => setLoading(false));
  }, [selectedCity]);

  /* Formate start and end date handler */
  const formatEventDate = (start, end) => {
    if (!start || !end) return "";

    const startDate = new Date(start);
    const endDate = new Date(end);

    const sameMonth = startDate.getMonth() === endDate.getMonth();
    const sameYear = startDate.getFullYear() === endDate.getFullYear();

    const startStr = startDate.toLocaleDateString("en-US", {
      month: "short",
      day: "numeric",
    });

    const endStr = endDate.toLocaleDateString("en-US", {
      month: sameMonth ? undefined : "short",
      day: "numeric",
      year: sameYear ? undefined : "numeric",
    });

    const yearStr = startDate.getFullYear();

    return `${startStr}–${endStr}, ${yearStr}`;
  };

  const handleRegister = (event) => {
    // ✅ Check if registration is open (using correct API field name)
    if (!event?.metadata?.isAttendeeRegistrationOpen) {
      toast.info(
        event?.metadata?.attendeeRegistrationMsg || "Registration is currently closed"
      );
      return;
    }

    const eventId = event?.metadata?.event_id;
    navigate(`/free-event-register/event/${eventId}`);
  };

 
const handleEventPage = (event) => {
  const eventId = event?.metadata?.event_id;

  if (!eventId) {
    console.error("Event ID not found");
    return;
  }

  window.open(
    `/eventpage/${eventId}`,
    "_blank",
    "noopener,noreferrer"
  );
};


  const handleShareClick = (e, event) => {
    e.stopPropagation();
    setShareEventId(event?.metadata?.event_id);
  };

  if (loading) {
    return (
      <p style={{ padding: "30px 0", textAlign: "center" }}>
        Loading events...
      </p>
    );
  }

  if (!events.length) {
    return (
      <p style={{ padding: "30px 0", textAlign: "center" }}>
        {selectedCity
          ? `No trending events found in ${selectedCity}.`
          : "No trending events found."}
      </p>
    );
  }

  return (
    <>
      <Swiper
        className="mySwiper cardDesign"
        spaceBetween={15}
        autoplay={{
          delay: 3500,
          disableOnInteraction: false,
          pauseOnMouseEnter: true,
        }}
        loop={true}
          speed={800}
        navigation
        modules={[Autoplay, Navigation]}
        breakpoints={{
          0: { slidesPerView: 2, slidesPerGroup: 1 },
          768: { slidesPerView: 2, slidesPerGroup: 1 },
          1024: { slidesPerView: 4, slidesPerGroup: 1 },
        }}
      >
        {events.map((item) => {
          // ✅ Console logs for debugging
          console.log("TRENDING ITEM =>", item);
          console.log("TRENDING METADATA =>", item.metadata);
          console.log("isAttendeeRegistrationOpen =>", item?.metadata?.isAttendeeRegistrationOpen);
          console.log("attendeeRegistrationMsg =>", item?.metadata?.attendeeRegistrationMsg);

          return (
            <SwiperSlide key={item.id}>
              <div className="flip-card" onClick={() => handleEventPage(item)}>
                <div className="flip-card-inner">
                  <div className="flip-card-back">
                    
                    {/* Image Section */}
                    <div className="card-img-wrap">
                      {item?.banner_file?.base64 ? (
                        <img
                          src={item.banner_file.base64}
                          alt={item?.metadata?.name}
                        />
                      ) : (
                        <div className="card-img-placeholder">
                          <i className="fas fa-calendar-alt"></i>
                        </div>
                      )}

                      {/* Event Type Badge */}
                      {item?.metadata?.event_type && (
                        <span className="card-event-type-badge">
                          {item.metadata.event_type}
                        </span>
                      )}
                    </div>

                    {/* Card Body */}
                    <div className="card-content">
                      <div className="card-meta-pills">
                        {item?.metadata?.start_date && (
                          <span className="card-date-pill">
                            <img
                              src={eventBackcardIcon}
                              alt=""
                              width="12"
                            />
                            {formatEventDate(
                              item?.metadata?.start_date,
                              item?.metadata?.end_date
                            )}
                          </span>
                        )}

                        {item?.metadata?.city && (
                          <span className="card-city-pill">
                            {item.metadata.city}
                          </span>
                        )}
                      </div>

                      <h4 className="card-title">
                        {item?.metadata?.name}
                      </h4>

                      {item?.metadata?.description && (
                        <p className="card-desc">
                          {item.metadata.description}
                        </p>
                      )}

                      {/* ✅ Updated button with registration open/close logic */}
                      <button
                        className={`card-register-btn ${
                          !item?.metadata?.isAttendeeRegistrationOpen
                            ? "disabled-btn"
                            : ""
                        }`}
                        onClick={(e) => {
                          e.stopPropagation();
                          handleRegister(item);
                        }}
                      >
                        {item?.metadata?.isAttendeeRegistrationOpen
                          ? "Register Event"
                          : "Registration Closed"}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </SwiperSlide>
          );
        })}
      </Swiper>
      {shareEventId && (
        <ShareModal
          eventId={shareEventId}
          onClose={() => setShareEventId(null)}
        />
      )}
    </>
  );
};

export default HometrendingEvents;